// extracted by mini-css-extract-plugin
module.exports = {"community-carousel":"CommunityBuzzCarousel_community-carousel__HwLPS","community-carousel__title":"CommunityBuzzCarousel_community-carousel__title__eO8qW"};